import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-select-list-modal',
  templateUrl: './select-list-modal.component.html',
  styleUrls: ['./select-list-modal.component.scss'],
})
export class SelectListModalComponent implements OnInit {
  @Input() title: string;
  @Input() options: string[] = [];

  public searchTerm = '';
  public filteredOptions: string[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.filteredOptions = [...(this.options || [])];
  }

  onSearch(event: any) {
    const value = (event?.detail?.value || '').toLowerCase();
    this.searchTerm = value;
    if (!value) {
      this.filteredOptions = [...(this.options || [])];
      return;
    }
    this.filteredOptions = (this.options || []).filter((opt) =>
      (opt || '').toLowerCase().includes(value)
    );
  }

  selectOption(option: string) {
    this.modalController.dismiss(option);
  }

  closeModal() {
    this.modalController.dismiss();
  }
}


